<script setup lang="ts"></script>

<template>
	<div class="h-full min-h-screen w-full bg-dark">
		<main class="h-full">
			<slot></slot>
		</main>
	</div>
</template>

<style scoped></style>
